function initCollapsibleContent(block) {
  const content = block.querySelector('.collapsible-content__content');
  const button = block.querySelector('.collapsible-content__button');

  const height = content.scrollHeight;
  block.style.setProperty('--max-height', `${height}px`);

  button.addEventListener('click', () => {
    block.classList.toggle('open');
  });
}

export default initCollapsibleContent;